import { Component, OnInit, ViewChild, ChangeDetectorRef}           from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators }      from '@angular/forms';
import { ErrorStateMatcher }                                        from '@angular/material/core';
import { Router, ActivatedRoute }                                   from '@angular/router';
import { first }                                                    from 'rxjs/operators';
import { Lightbox }                                                 from 'ngx-lightbox';
import { NgxSpinnerService }                                        from 'ngx-spinner';
import * as OT                                                      from '@opentok/client';

import { AlertService, ProctorService, OpentokService }             from '../_services';
import { Globals }                                                  from '../_helpers';
import { SearchFilterPipe }                                         from '../_pipes';

@Component({
    selector: 'app-proctor',
    templateUrl: './clientview.component.html',
    providers: [ OpentokService ]
})


export class ClientviewComponent implements OnInit {

    pagetitle: string = '';
    batch_name: string = '';
    exam_name: string = '';
    exam_date;
    statusMsg: string = '';
    localData = {};
    localBatch = {};
    localExam = {};
    loading = false;
    submitted = false;
    returnUrl: string;
    inProgress: number;
    dispalyData = [];
    isStudent = false;
    videoIndex: number = 0;
    videoSrc: string = '';
    infoTitle: string = '';
    name : string = '';
    mobile : string = '';
    email : string = '';
    query: string = '';
    aadhar:string = '';
    location: string = '';
    imageSrc: string = '/assets/images/proctor-img.jpg';

    examid;
    username;
    contact;
    usercode;

    private _albums: Array<any> = [];
    private _videoalbums: Array<any> = [];

    session: OT.Session;
    streams: Array<OT.Stream> = [];
    changeDetectorRef: ChangeDetectorRef;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private proctorService: ProctorService,
        private alertService: AlertService,
        private globals: Globals,
        private _lightbox: Lightbox,
        private spinner: NgxSpinnerService,
        private ref: ChangeDetectorRef, 
        private opentokService: OpentokService
    ) 
    { this.changeDetectorRef = ref; }

  	ngOnInit() {
        /* clear loaclStorege */
        localStorage.clear();
        this.examid = atob(this.route.snapshot.paramMap.get("exam_id"));
        this.username = atob(this.route.snapshot.paramMap.get("username"));
        this.contact = atob(this.route.snapshot.paramMap.get("contact"));

/*        console.log(this.examid);
        console.log(this.username);
        console.log(this.contact);*/

    	this.isStudent = true;
        this.pagetitle = 'Student';
    	this.getStudentDetailsForClient();
  	}

  	private getStudentDetailsForClient(){
        this.spinner.show();
  		this.submitted = true;
        this.proctorService.getStudentsForClient(this.globals.root_url, this.examid, this.username, this.contact)
          .pipe(first())
          .subscribe(
            data => {
                if(data.code == 1000){
                    this.dispalyData = data.students;
                    this.usercode = data.usercode;
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.loading = false;
                    this.globals.statusOpen(data.status, '/exams');
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
  	}

    public imgGallery(entity_id:number, gallary_type:string){
        this.spinner.show();
        this.submitted = true;
        this.proctorService.getImagesGallary(this.globals.root_url, this.usercode, entity_id, gallary_type,this.localExam['exam_id'])
          .pipe(first())
          .subscribe(
            data => {
                if(data.code == 1000){
                    this._albums =  data.album;
                    /*for (let i = 1; i <= 4; i++) {
                        const src = 'demo/img/image' + i + '.jpg';
                        const caption = 'Image ' + i + ' caption here';
                        const thumb = 'demo/img/image' + i + '-thumb.jpg';
                        const album = {
                            src: src,
                            caption: caption,
                            thumb: thumb
                        };
                 
                        this._albums.push(album);
                    }*/
                    this.open(1);
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.loading = false;
                    this.globals.statusOpen(data.status);
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }

    public open(index: number): void {
        // open lightbox
        console.log(this._albums);
        if(typeof this._albums != 'undefined' && this._albums.length > 0)
            this._lightbox.open(this._albums, index);
    }
 
    public close(): void {
        // close lightbox programmatically
        this._lightbox.close();
    }

    public videoGallery(entity_id:number, gallary_type:string){
        this.spinner.show();
        this.submitted = true;
        this.proctorService.getVideoGallary(this.globals.root_url, this.usercode, entity_id, gallary_type,this.examid)
          .pipe(first())
          .subscribe(
            data => {
                if(data.code == 1000){
                    this._videoalbums =  data.album;
                    this.videoOpen(1);
                }
                else{
                    this.loading = false;
                    this.globals.statusOpen(data.status);
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }

    public videoOpen(index:number){
        document.getElementsByTagName('body')[0].style.overflow = "hidden"
        this.videoIndex = 0;
        this.videoSrc = this._videoalbums[this.videoIndex].src;
        let vmodal = document.getElementById('vmodal');
        vmodal.style.display = 'block';
    }

    public prevVideo(){
        if(this.videoIndex > 0){
            --this.videoIndex;
            this.videoSrc = this._videoalbums[this.videoIndex].src;
        }
    }

    public nextVideo(){
        let totalVideo = (this._videoalbums.length) - 1;
        if(this.videoIndex < totalVideo){
            ++this.videoIndex;
            this.videoSrc = this._videoalbums[this.videoIndex].src;
        }
    }

    public customModalClose(modal_id:string){
        document.getElementsByTagName('body')[0].style.overflow = "auto";
        let modal = document.getElementById(modal_id);
        modal.style.display = 'none';
    }

    public getInfo(entity_id:number, info_type:string){
        this.spinner.show();
        this.submitted = true;
        this.proctorService.getInformation(this.globals.root_url, this.usercode, entity_id, info_type,this.localExam['exam_id'])
          .pipe(first())
          .subscribe(
            data => {
                if(data.code == 1000){
                    let info = data.info;
                    this.infoTitle = 'Information';
                    this.name = info.name;
                    this.mobile = info.mobile;
                    this.email = info.email;
                    this.imageSrc = info.photo;
                    this.aadhar = info.aadhar;
                    this.location = info.location;

                    this.infoOpen();
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.loading = false;
                    this.globals.statusOpen(data.status);
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }

    public infoOpen(){
        document.getElementsByTagName('body')[0].style.overflow = "hidden";
        let infomodal = document.getElementById('infomodal');
        infomodal.style.display = 'block';
    }

    public vivaAnswer(id:number){
        this.router.navigate(['/viva', id]);
    }

    public liveStreemimg(student_id:number, isVivaDone:number){
        if(isVivaDone == 2 || isVivaDone == 3){
            return false;
        }
        else{
            let isLiveError = false;
            this.spinner.show();
            this.submitted = true;
            this.proctorService.getSessionToken(this.globals.root_url, this.usercode, student_id, this.localExam['exam_id'])
              .pipe(first())
              .subscribe(
                data => {
                    if(data.code == 1000){
                        document.getElementsByTagName('body')[0].style.overflow = "hidden";
                        let livevideo = document.getElementById('livevideo');
                        livevideo.style.display = 'block';

                        let TOKEN = data.token;
                        let SESSION_ID = data.session_id;
                        this.opentokService.initSession(TOKEN, SESSION_ID).then((session: OT.Session) => {
                            this.session = session;
                            this.session.on('streamCreated', (event) => {
                                this.streams.push(event.stream);
                                this.changeDetectorRef.detectChanges();
                            });
                            this.session.on('streamDestroyed', (event) => {
                                const idx = this.streams.indexOf(event.stream);
                                if (idx > -1) {
                                    this.streams.splice(idx, 1);
                                    this.changeDetectorRef.detectChanges();
                                }
                            });
                        })
                        .then(() => this.opentokService.connect())
                        .catch((err) => {
                            if(err){
                                console.error(err.message);
                                this.globals.statusOpen(err.message);
                            }
                        });

                    }
                    else if(data.status == 'COM_TOKEN_ERROR'){
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else{
                        this.loading = false;
                        this.globals.statusOpen(data.status);
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
        }
    }
}


